import V1PdfBase from './PDFBases/v1/pdfBase';
let pdfMake = require('pdfmake/build/pdfmake.js');
let pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function createPDF(report) {
    const pdf = new V1PdfBase(report, {reportName: report.name, timeStamp: report.createdAt});
    return pdfMake.createPdf(pdf.build());
}
